<div class="auth-shell">
	<section class="login-card">
		<h2 class="card-title">{{ title() }}</h2>
		<p class="card-subtitle">{{ subtitle() }}</p>

		<form (ngSubmit)="onLogin()" class="login-form">
			<label for="auth-username" class="label">Username</label>
			<input id="auth-username" type="text" name="username" [(ngModel)]="username" autocomplete="username"
				class="input" />

			<label for="auth-password" class="label">Password</label>
			<div class="password-wrap">
				<input id="auth-password" [name]="'password'" [type]="showPassword() ? 'text' : 'password'"
					[(ngModel)]="password" autocomplete="current-password" class="input password-input" />
				<button type="button" class="eye-btn" (click)="togglePasswordVisibility()"
					[attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'">
					<svg *ngIf="!showPassword()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="eye-icon"
						fill="none" stroke="currentColor" stroke-width="2">
						<path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12Z"></path>
						<circle cx="12" cy="12" r="3"></circle>
					</svg>
					<svg *ngIf="showPassword()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="eye-icon"
						fill="none" stroke="currentColor" stroke-width="2">
						<path d="m3 3 18 18"></path>
						<path d="M10.6 10.6a2 2 0 0 0 2.8 2.8"></path>
						<path d="M9.9 5.1A10.9 10.9 0 0 1 12 5c7 0 11 7 11 7a21.8 21.8 0 0 1-5.1 5.9"></path>
						<path d="M6.6 6.6A21.8 21.8 0 0 0 1 12s4 7 11 7a10.7 10.7 0 0 0 5-.9"></path>
					</svg>
				</button>
			</div>

			<div *ngIf="error()" class="error-text">{{ error() }}</div>

			<button type="submit" class="login-btn" [disabled]="isSubmitting()">
				{{ isSubmitting() ? 'Signing in...' : 'Sign In' }}
			</button>
		</form>
	</section>
</div>
